<app-print-layout (cancelar)="cancelar()">
  <div class="card-body">
    <div>
      <div class="row mb-1">
        <div class="col-md-12" style="font-weight: bold;">
          Papéis de Trabalho
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <table class="table" style="border: 1px solid #ccc">
            <thead>
              <th>Nome</th>
              <th class="border-coluna">Tipo</th>
              <th class="border-coluna">Arquivos/Link</th>
              <th class="border-coluna">Justificativa</th>
            </thead>
            <tbody>
              <tr *ngFor="let item of model">
                <td>
                  <b>{{ getSigla(item) }}</b> - 
                    {{ item.nomePapel }}
                    {{ getSituacao(item) }}
                </td>
                <td class="border-coluna">
                  {{ item.idTipoAceitavel == 1 ? "Coletado" : (item.idTipoAceitavel == 2 ? "Não-Coletado" : "Produzido pelo Auditor") }}                  
                </td>
                <td class="border-coluna">
                  <div *ngIf="item.idTipoAceitavel != 2">                      
                    <div class="row mb-1" *ngFor="let arquivo of item.arquivos">
                      <div class="col-md-12">
                        <div>
                          <table style="width: 100%;border:none;" [cellPadding]="0" [cellSpacing]="0">
                            <tr>
                              <td>
                                {{ arquivo.nome }}
                              </td>
                            </tr>
                          </table>
                        </div> 
                      </div>
                    </div>                                 
                  </div>
                  <div *ngIf="item.idTipoAceitavel == 2">
                    <div class="row mb-1">
                      <div class="col-md-12">
                        {{ item.link }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="border-coluna">
                  <b *ngIf="exibeJustificativa(item)">{{ item.justificativa }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>  
  </div>
  
</app-print-layout>